<template>
    <div id="playLateGame">
      <headerPage :title="title" :iconSrc='iconSrc' :headerSty='headerSty'></headerPage>
      <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
      <gameImg :game='game'></gameImg>
      <div class="text">
          <div><span class="span" :style="colorSty">{{data.stayUpLateTime}}</span>你还在玩这款游戏</div>
          <!-- <div>看来这个世界里一定有着你所珍视的事物吧。</div> -->
          <div><span>{{data.text}}</span><img src="../../assets/image/steam/right_big.png"></div>
      </div>
      <footerPage class="footerPage"></footerPage>
      <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
</template>
  
  <script>
  import headerPage from '../../components/header.vue'
  import gameImg from '../../components/gameImg.vue'
  import footerPage from '../../components/footer.vue'
  import footerBg from '../../components/footerBg.vue'
import headerBg from '../../components/headerBg.vue'
  export default {
      props:{
          data:{
              type:[Object]
          }
      },
      data(){
          return {
              title:'熬夜畅玩游戏',
              iconSrc:require('../../assets/image/'+this.$route.query.type+'/'+this.$route.query.type+'_small.png'),
               headerSty:{
                padding:'7.2rem 0 0 1.95rem'
              },
              footerBg:{
                top:'27rem',
                background: 'url('+require('../../assets/image/'+this.$route.query.type+'/playLateGameBg.png')+')',
                backgroundSize: '100%',
                backgroundRepeat:'no-repeat',
                backgroundPosition: 'bottom right',
                // backgroundAttachment: 'fixed',
              },

            headerBg:{
                height:'12.45rem',
                background: 'url('+require('../../assets/image/steam/headerBg.png')+')',
                backgroundRepeat:'no-repeat',
                backgroundSize:'300%',
                backgroundPosition: '8% 15%',
                // backgroundAttachment: 'fixed',
            },
            game:{},
            colorSty:{},
          
          }
      },
      mounted(){
          if(this.$route.query.type=='steam'){
              this.colorSty={
                  color:'#5EE6FF'
              }
          }else if(this.$route.query.type=='psn'){
              this.colorSty={
                  color:'#5EA6FF'
              }
          }else if(this.$route.query.type=='xbox'){
              this.colorSty={
                  color:'#5EFF97'
              }
          }else if(this.$route.query.type=='epic'){
              this.colorSty={
                  color:'#FF5E5E'
              }
          }
           this.$set(this.game,'gameImg',this.data.gameCover)
            this.$set(this.game,'gameName',this.data.gameName)
      },
      
        methods:{
        
            getNumber(val){
                if(val){
                    return val.toFixed(0)
                }
                
            }
    
        },
      components:{
          headerPage,
          gameImg,
            footerPage,
            footerBg,
        headerBg
      }
  }
  </script>
  
  <style>
 #playLateGame .text{
      padding: 0 1.95rem;
      font-size: 0.7rem;
      font-family: Source Han Sans CN;
      color:rgba(255, 255, 255, 0.8);
  }
 #playLateGame .text div{
      margin-bottom: 1.35rem;
  }
  #playLateGame .text .span{
      font-size: 1.4rem;
      font-family: Impact;
      color: #5EE6FF;
      margin-right: 0.6rem;
  }
#playLateGame .text>div:last-child{
        display: flex;
        align-items: end;
        justify-content: space-between;
    }
    #playLateGame .text>div:last-child>span{
        margin-bottom: 0.15rem;
    }
    #playLateGame .text img{
        width: 1.8rem;
        height: 1.5rem;
      
    }
  </style>